<script lang="ts">
	//UI
	import SideIcons from "@hitit/hub/src/components/SideIcons.svelte";
	//Utils
	import { link } from "svelte-routing";
	import { pick } from "svelte-routing/src/utils";
	import { globalHistory } from "svelte-routing/src/history";
	import { t } from "@hitit/hub/src/stores";
	//Types
	//Props

	export let storeId: string;
	export let linkClickAfterHanlder = () => {};
	//Constants
	//Variables
	let path = window.location.pathname;
	$: basePath = `/store/${storeId}`;
	$: sidenavItems = [
		{
			iconType: "Manage",
			label: $t("mbr.stores.manage"),
			route: basePath + "/",
			to: basePath + "/",
		},
		{
			iconType: "Dashboard",
			label: $t("hub.dashboard.title"),
			route: basePath + "/dashboard",
			to: basePath + "/dashboard",
		},
		{
			iconType: "Revenue",
			label: $t("hub.revenue.title"),
			route: basePath + "/revenue/*",
			to: basePath + "/revenue/saleshistory",
		},
		{
			iconType: "Store",
			label: $t("hub.store.title"),
			route: basePath + "/store/*",
			to: basePath + "/store",
		},
		{
			iconType: "Product",
			label: $t("hub.product.title"),
			route: basePath + "/product/*",
			to: basePath + "/product/item",
		},
		{
			iconType: "Point",
			label: $t("hub.point.title"),
			route: basePath + "/earning/*",
			to: basePath + "/earning/history",
		},
		{
			iconType: "Place",
			label: $t("hub.place.title"),
			route: basePath + "/place",
			to: basePath + "/place",
		},
		{
			iconType: "Logging",
			label: $t("mbr.debug.eventLogging"),
			route: basePath + "/eventLogging/*",
			to: basePath + "/eventLogging",
		},
	];
	$: routes = sidenavItems?.map((i) => ({ path: i.route })) || [];
	$: matched = pick(routes, path);

	//Functions
	//Do
	globalHistory.listen((v) => (path = v.location.pathname));

</script>

<div class="container">
	{#each sidenavItems as item}
		<a href={item.to} use:link on:click={linkClickAfterHanlder}>
			<div class="img-box">
				<SideIcons
					iconType={item.iconType}
					active={matched?.route.path === item.route} />
			</div>
			<span class:active={matched?.route.path === item.route}>
				{item.label}
			</span>
		</a>
	{/each}
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 40px;
		flex-grow: 1;
		padding: 0px 0px 20px 20px;
		box-sizing: border-box;
		overflow-y: auto;
		a {
			display: flex;
			gap: 10px;
			transition: color 0.5s;
			color: var(--lightGrey);

			&:hover {
				color: rgb(223, 223, 223);
			}

			.img-box {
				width: 20px;
				height: 20px;
				position: relative;
			}

			span {
				flex-grow: 1;

				&.active {
					color: white;
					font-weight: 500;
				}
			}
		}
		&::-webkit-scrollbar {
			width: 2px;
		}
		&::-webkit-scrollbar-track {
			background-color: transparent;
		}
		&::-webkit-scrollbar-thumb {
			background-color: #bcbfc3;
		}
	}

	//Desktop
	@include DesktopSize {
		.container {
			gap: 42px;
			padding: 0px 0px 50px 50px;

			a {
				gap: 14px;
				align-items: center;
				font-size: 1.25rem;
				.img-box {
					width: 26px;
					height: 26px;
				}
			}
		}
	}

</style>
